import React from 'react';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import BreadcrumbArrow from './svgs/breadcrumb-arrow.svg';

interface BreadcrumbProps {
  elements: {
    link?: string;
    text: string;
  }[];
  useSVG?: boolean;
}

// Takes in array of {text, link} or {text} if last element
function Breadcrumb({ elements, useSVG = false }: Readonly<BreadcrumbProps>) {
  const { tt } = useUiComponentsInternationalContext();

  if (!elements || elements.length === 0) {
    return null;
  }

  return (
    <nav aria-label={tt(s => s.breadcrumbComponent.breadcrumbAriaLabel)}>
      <ol className="list-none p-0 m-0">
        {elements.map(({ text, link }, index) =>
          index === elements.length - 1 ? (
            // Last element
            <li key={text} className="inline">
              <div className="inline text-[#5d5d5d]">
                <span>{text}</span>
              </div>
            </li>
          ) : (
            // Middle elements
            <li key={text} className="inline">
              <div className="inline text-[#5d5d5d]">
                <LocalizedLink to={`${link}`} className="hover:underline">
                  {text}
                </LocalizedLink>
                {useSVG ? (
                  <BreadcrumbArrow aria-hidden />
                ) : (
                  <span aria-hidden>{' > '}</span>
                )}
              </div>
            </li>
          )
        )}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
